//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from './global/TransitionExpand';
export default {
  props: {},
  data: function () {
    return {};
  },
  computed: {
    letters() {
      return letters;
    },
    sortByAlpha() {
      return this.$store.state.searchQuery.sortByAlpha;
    },
  },
  methods: {
    alphaClick(c) {
      this.$store.commit('setSortByAlpha', c);
      this.$emit('executeSearch');
    },
  },
};

const letters = [
  { c: 'All', d: 0 },
  { c: 'A', d: 0 },
  { c: 'B', d: 0 },
  { c: 'C', d: 0 },
  { c: 'D', d: 0 },
  { c: 'E', d: 0 },
  { c: 'F', d: 0 },
  { c: 'G', d: 0 },
  { c: 'H', d: 0 },
  { c: 'I', d: 0 },
  { c: 'J', d: 0 },
  { c: 'K', d: 0 },
  { c: 'L', d: 0 },
  { c: 'M', d: 0 },
  { c: 'N', d: 0 },
  { c: 'O', d: 0 },
  { c: 'P', d: 0 },
  { c: 'Q', d: 1 },
  { c: 'R', d: 0 },
  { c: 'S', d: 0 },
  { c: 'T', d: 0 },
  { c: 'U', d: 1 },
  { c: 'V', d: 0 },
  { c: 'W', d: 0 },
  { c: 'X', d: 1 },
  { c: 'Y', d: 0 },
  { c: 'Z', d: 0 },
];
